module.exports = __webpack_public_path__ + "img/ku5.9d75893f.png";